import { render, staticRenderFns } from "./artist-show.vue?vue&type=template&id=f1419fdc&"
import script from "./artist-show.vue?vue&type=script&lang=js&"
export * from "./artist-show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports